export const tableOption = {
  border: true,
  index: false,
  dialogWidth: '460px',
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'left',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      width: 300,
      editVisdiplay: false,
      addVisdiplay: false
    },
    {
      label: '敏感词',
      prop: 'word',
      width: 580,
      search: true,
      span: 24,
      rules: [{
        required: true,
        message: "不能为空且不超过30个字符",
        trigger: "blur",
        max: 30
      }]
    }
  ]
}
